import { StateNode } from '@ansys-internal/awf-angular/store';

export class SelectedConfigurationsState implements StateNode<string[]> {
  key: string = 'selectedConfigurations';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => string[] = () => [];
}
